import { ToastProvider } from '@idexx-laboratories/spot-react';
import '@idexx-laboratories/spot/dist/spot_library.min.css';
import { Provider as MobXProvider } from 'mobx-react';
import React, { ReactElement } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Callback from './pages/Callback/Callback';
import Deployment from './pages/Deployment/Deployment';
import paths from './paths';
import Auth0ProviderWithNavigate from './providers/Auth0ProviderWithNavigate';
import RootStore from './store/RootStore';
import './styles/index.scss';

const rootStore = new RootStore();

const App = (): ReactElement => (
  <ToastProvider>
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <MobXProvider {...rootStore}>
          <Routes>
            {paths
              .filter(path => path.route)
              .map(path => {
                const { Component, Layout } = path;
                return (
                  <Route
                    key={path.route}
                    path={path.route}
                    element={
                      <Layout>
                        <Component />
                      </Layout>
                    }
                  />
                );
              })}
            <Route path='/callback' element={<Callback />} />
            <Route path='/deployment' element={<Deployment />} />
            <Route path='*' element={<Navigate to='/' />} />
          </Routes>
        </MobXProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </ToastProvider>
);

const root = createRoot(document.getElementById('root')!);
root.render(<App />);
